import BeforeAfterCommunication from '~/pages/communication/beforeAfter/libs/components/BeforeAfterCommunication'
import { TPageProps } from '~/shared/types/commonTypes'

const BeforeAfterCommunicationPage = (props: TPageProps) => (
  <BeforeAfterCommunication {...props} />
)

export default BeforeAfterCommunicationPage
